import {
    TRegUnwrapData
} from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegUnWrap/types';
import { TChangeDetailsProps } from '@interlayer/js/app/components/main/Registration/types';

const STATE_KEY = 'state';

export const filterFormDataUserDetails = (data: (Partial<TRegUnwrapData> & {
    address?: string;
}) | Record<string, never> = {}, countrycode = 'GB'): TChangeDetailsProps => {
    const parsedData = {
        title: data.gender || '',
        phone: data.phone || '',
        cellphone: data.phone || '',

        address: data.address || `${data.house || ''} ${data.street || ''}`.trim(),
        city: data.city || '',
        state: data.state || '',
        homeVenue: data.homeVenue || '',
        zip: data.zip || '',

        email: data.email || ''
    };

    const filteredData: Record<string, string> = {};

    Object.entries(parsedData).forEach(([key, value]) => {
        if (value || key === STATE_KEY) {
            filteredData[key] = value;
        }
    });

    const addressDetails = {
        buildingNumber: data.house || data.address?.split(' ')[0] || '',
        streetName: data.street || data.address
            ?.split(' ')
            .slice(1)
            .join(' ') || ''
    };

    return {
        addressDetails,
        dataMap: filteredData,
        contactAddress: {
            addressDetails,
            countrycode,
            zip: filteredData.zip,
            city: filteredData.city
        }
    };
};
